export const colorPickerColors = [
  '#f44336',
  '#e91e63',
  '#9c27b0',
  '#673ab7',
  '#3f51b5',
  '#2196f3',
  '#03a9f4',
  '#00bcd4',
  '#009688',
  '#4caf50',
  '#8bc34a',
  '#cddc39',
  '#ffeb3b',
  '#ffc107',
  '#ff9800',
  '#ff5722',
  '#795548',
  '#607d8b',
  '#BC3C3D',
  '#B44C24',
  '#A85E03',
  '#1A5934',
  '#002772',
  '#001E56',
  '#000000',
  '#ffffff',
  '#e0e0e0',
  '#f3f4f6',
];

/**
 * Semantic palette for workflow presets.
 */
export const workflowPresetColors = {
  active: '#1A5934', // active, accepted, started, move-ins
  attention: '#B44C24', // unanswered, drafts, not delegated
  warning: '#A85E03', // expiring, pending, not accepted
  critical: '#BC3C3D', // terminated, overdue, rejected, failed
  info: '#002772', // upcoming, move-outs, historic look-backs
  infoAlt: '#001E56', // neutral, separates sibling groups from `info`
} as const;
